// extracted by mini-css-extract-plugin
export default {"page":"x0-z","cartModal":"y0-z","checkout":"z0-z","placeholder":"A0-z","account":"B0-z"};